/** How long to wait for the browser to leave fullscreen before going on anyway. */
const EXIT_TIMEOUT_MS = 1000;

/**
 * Leave fullscreen if what is in fullscreen is a tool board's frame, and say
 * when that is done.
 *
 * A board is taken off the stage only after this resolves. Removing a frame
 * that is in fullscreen — or still on its way out of it — can leave the
 * browser on a frozen, empty screen with the call underneath it unreachable,
 * which for the patient reads as the call having hung.
 */
export function leaveBoardFullscreen(): Promise<void> {
    const element = document.fullscreenElement;
    if (!element || !element.closest?.("[data-tool-board]") || !document.exitFullscreen) {
        return Promise.resolve();
    }
    const exited = document.exitFullscreen().catch(() => undefined);
    const timedOut = new Promise<void>((resolve) => setTimeout(resolve, EXIT_TIMEOUT_MS));
    return Promise.race([exited, timedOut]);
}
